import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

type BannerBodyProps = {
    children: string;
};

const bodyCss = css({
    margin: 0,
    fontSize: token("space.150"),
    lineHeight: token("space.250")
});

const BannerBody = ({ children }: BannerBodyProps) => {
    return <p css={bodyCss}>{children}</p>;
};
export default BannerBody;
